import {
  getFunctions,
  connectFunctionsEmulator,
  httpsCallable,
} from "firebase/functions";
import app from "../config/firebasedeconfig";

const functions = getFunctions(app, "us-central1");

if (app.options.projectId === "demo-moviefrenzy") {
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}

const setLike = httpsCallable(functions, "setForumLike");
const deleteReply = httpsCallable(functions, "deleteForumReply");
const deletePost = httpsCallable(functions, "deleteForumPost");

export const setForumLike = async (data) =>
  (await setLike(data)).data;

export const deleteForumReply = async (data) =>
  (await deleteReply(data)).data;

export const deleteForumPost = async (data) =>
  (await deletePost(data)).data;